var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.allowed)?_c('div',{staticClass:"internal-container"},[_c('InternalHeader',{attrs:{"title":"Konfiguration","icon":"build"}}),_c('SliderManager'),_c('VariableManager')],1):_vm._e(),_c('div',{staticStyle:{"height":"100px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }